import React from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../hybrid/wrappers';
import { generateGridStyles } from '../components/helpers';

const Check = ({ val, getHandlers, gridStyles, name }) => {
    const { stylers, classes, existSt } = generateGridStyles(gridStyles, name);
    if (name === 'deleted' ? !Boolean(val) : Boolean(val)) {
        return (
            <p {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper}>
                {svgSprite(gridStyles[name]?.ico?.checkIcon || 'check', {
                    className: classes.ico,
                    style: existSt('ico') || {
                        fill: 'var(--greenDeepColor)',
                        width: '15px',
                        height: '11px'
                    }
                })}
            </p>
        );
    }
    return (
        <p {...getHandlers(false)} className={classes.wrapper} style={stylers.wrapper}>
            {svgSprite(gridStyles[name]?.ico?.noCheckIcon || 'cross', {
                className: classes.ico,
                style: existSt('ico') || {
                    fill: 'var(--redDarkColor)',
                    width: '13px',
                    height: '13px'
                }
            })}
        </p>
    );
};
Check.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default Check;
